'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = json2xml;
var indentPad = function indentPad(n) {
  return Array(n + 1).join(' ');
};

var TAG_CONVERSION = {
  'mj-dev': 'mj-raw'
};

var lineAttributes = function lineAttributes(attrs) {
  return Object.keys(attrs).filter(function (key) {
    return key !== 'passport';
  }).map(function (key) {
    return key + '="' + attrs[key] + '"';
  }).sort().join(' ');
};

function json2xml(node) {
  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var tagName = node.tagName;
  var children = node.children,
      content = node.content,
      attributes = node.attributes;


  if (tagName in TAG_CONVERSION) {
    tagName = TAG_CONVERSION[tagName]; // eslint-disable-line prefer-destructuring
  }

  var space = indentPad(indent);

  var attrs = attributes && ' ' + lineAttributes(attributes) || '';

  if (!attrs.trim()) {
    attrs = '';
  }

  var inside = content && '\n' + space + '  ' + content + '\n' + space || children && '\n' + children.map(function (c) {
    return '' + json2xml(c, indent + 2);
  }).join('\n') + '\n' + space || '';

  return space + '<' + tagName + attrs + '>' + inside + '</' + tagName + '>';
}